import React from "react";
import { ApiProvider, useApi } from "./contexts/ApiContext";
import ApiKeyScreen from "./components/ApiKeyScreen";
import MainScreen from "./components/MainScreen";
import "./App.css";

const AppContent: React.FC = () => {
  const { apiKey } = useApi();

  return (
    <div className="app">{apiKey ? <MainScreen /> : <ApiKeyScreen />}</div>
  );
};

const App: React.FC = () => {
  return (
    <ApiProvider>
      <AppContent />
    </ApiProvider>
  );
};

export default App;
